import React, { Component } from "react";
import Maintemplate from "../mainTemplate";
import BillDetail from "../../shared/bill/billDetail";

class BillDetailPRO extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Maintemplate>
      <BillDetail 
        billId={this.props.match.params.billId}
        closeUrl={`/providerSite/bills`}
        from={'proSite'} />
    </Maintemplate>
  }
}

export default BillDetailPRO;
